





































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import Gallery from '../components/gallery/gallery.component.vue';
import { Camera } from '@/models/camera';
import { Project } from '@/models/project';
import { User } from '@/models/user';

type GalleryExpose = Vue & { goToClosestPhoto: (d: Date) => void };

@Component({
  components: {
    Gallery,
  },
})
export default class CameraGalleryList extends Vue {
  @Prop({ required: true }) readonly project!: Project;
  @Prop({ required: true }) readonly isPremium!: boolean;
  @Prop({ required: true }) readonly guest!: boolean;
  @Prop({ required: true }) readonly user!: User;
  @Prop({ type: Boolean, default: false }) readonly syncGalleries!: boolean;
  @Prop({ type: Number, default: 2 }) readonly perRow!: number;

  @State('premium', { namespace: 'project' }) readonly ownerPremium!: boolean;

  cameras: Camera[] = [];
  newPhotoAvailable = false;
  isSwitchEnabled = true;
  private galleryComparaison: string | null = null;

  mounted(): void {
    this.loadCameras();
  }

  loadCameras(): void {
    if (this.project && this.project.cameras) {
      // eslint-disable-next-line no-console
      console.log('Cameras:', this.project.cameras);
      this.cameras = this.project.cameras;
    }
  }

  get gridStyle(): Record<string, string> {
    const cols = Math.min(Math.max(this.perRow, 1), 6);
    return {
      '--cols': String(cols), // garde-fou si tu veux garder la var
      gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`, // ✅ direct
    };
  }

  refreshPhoto(cameraId: string): void {
    // eslint-disable-next-line no-console
    console.log(`Refreshing photos for camera ID: ${cameraId}`);
    // TODO: logique de rafraîchissement si nécessaire
  }

  onPhotoChanged(date: Date, sourceCameraId: string): void {
    if (!this.syncGalleries) return;

    this.$nextTick(() => {
      this.cameras.forEach((cam) => {
        if (cam.id === sourceCameraId) return;

        const refName = 'gallery-' + cam.id;
        const galleryRef = this.$refs[refName];

        let galleryInstance: GalleryExpose | undefined;

        if (Array.isArray(galleryRef)) {
          galleryInstance = galleryRef[0] as GalleryExpose;
        } else {
          galleryInstance = galleryRef as GalleryExpose;
        }

        if (galleryInstance && typeof galleryInstance.goToClosestPhoto === 'function') {
          galleryInstance.goToClosestPhoto(date);
        } else {
          // eslint-disable-next-line no-console
          console.warn('galleryRef or goToClosestPhoto not found for camera', cam.id);
        }
      });
    });
  }

  galleryKey(cameraId: string): string {
    return cameraId;
  }
}
